const style = document.createElement("style");
style.textContent = `
#potvrzeni {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 2147483647 !important;
    pointer-events: auto !important;
    background-color: rgba(0, 0, 0, 0.900);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 16px;
}

#overlay-text{
    font-size: 2rem;
    color: white;
}

#button-yes, #button-no{
    font-size: 1rem;
    background-color: rgb(169, 87, 108);
    border-radius: 18px;
    padding: 1rem;
    border: 0px;
    color: white;
}

#button-yes:hover, #button-no:hover{
    background-color: rgb(117, 60, 75);
}

#options{
    display: flex;
    flex-direction: row;
    gap: 20px
}
`;
document.head.appendChild(style);


const alreadyShown = localStorage.getItem("popupShown");

if (!alreadyShown) {
  document.body.insertAdjacentHTML("beforeend", `
    <div id="potvrzeni">
        <p id="overlay-text">Je Vám více než 18 let?</p>
        <div id="options">
            <button id="button-yes">Ano</button>
            <button id="button-no">Ne</button>
        </div>
    </div>
  `);
    const potvrzeni = document.getElementById("potvrzeni")
    document.getElementById("button-yes").addEventListener("click", function () {
    potvrzeni.classList.remove("show");
    potvrzeni.style.display = "none";
  localStorage.setItem("popupShown", "true");
})}

document.getElementById("button-no")?.addEventListener("click", function(){
    location.replace("about:blank")
})